import { useContext, useState, useRef, useEffect } from "react";
import Tabs from "../shared/Tabs/Tabs";
import { screenSizeContext } from "@/app/store/context/screenSizesContext";
import { StickyNavProps } from "./types";
import gsap from "gsap";
import CustomButton from "../shared/CustomButton";
import { useGetInTouchPopupContext } from "@/app/store/context/getInTouchPopupContext";
import * as gtag from "@/app/utils/gtag";

const StickyNavComponent = ({ TabsData }: { TabsData: StickyNavProps[] }) => {
  const [activeTab, setActiveTab] = useState<string | number>(TabsData?.[0]?.value || ''); // Default to the first tab
  const [activeRef, setActiveRef] = useState<number>(0);
  const [isSticky, setIsSticky] = useState(false);
  const { isIpad } = useContext(screenSizeContext);
  const tabsContainerRef = useRef<HTMLDivElement>(null);  
  
  const isScrollingRef = useRef(false);
  const stickyContainerRef = useRef<HTMLDivElement>(null);  

  const overviewRef = useRef<Element | null>(null);
  const galleryRef = useRef<Element | null>(null);
  const perksRef = useRef<Element | null>(null);
  const nearbyRef = useRef<Element | null>(null);
  const finishingRef = useRef<Element | null>(null);
  const partnersRef = useRef<Element | null>(null);
  const scrollDelayRef = useRef<any>(null);

	const [navRefs,setNavRefs] = useState([
		overviewRef,
		galleryRef,
		perksRef,
		nearbyRef,
		finishingRef,
		partnersRef, 
	])

  // Handle tab click
  const handleTabClick = (tabRef: React.RefObject<HTMLElement>, tabValue: string) => {
    const banner = document.querySelector(".banner") as HTMLElement;
    if (isIpad) window.scrollTo({ top: tabRef.current?.offsetTop + banner?.offsetHeight - 80, behavior: "smooth" });
    else {
      scrollDelayRef.current?.kill();
      window?.lenis?.scrollTo(tabRef.current?.offsetTop + banner?.offsetHeight - 40, { duration: 0.8 });
      isScrollingRef.current = true;
      scrollDelayRef.current = gsap.delayedCall(0.8, () => isScrollingRef.current = false);
    }
    setActiveTab(tabValue);
  };

  // Handle scroll to detect the active section
  const handleScroll = () => {
    // console.log(isScrollingRef.current, "<--->")
    if(!isScrollingRef.current) {
      TabsData.forEach((tab: any) => {
        if (tab.ref.current) {
          const banner = document.querySelector(".banner") as HTMLElement;
          const offsetTop = tab.ref.current.offsetTop + banner?.offsetHeight;
          
          if (window.scrollY > offsetTop - 50) {
            setActiveTab(tab.value);
            setActiveRef(tab.id);
          }
        }
      });
    }
  };

  // // Attach scroll event listener
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Detect when sticky nav becomes sticky
  useEffect(() => {
    const checkSticky = () => {
      if (stickyContainerRef.current) {
        const rect = stickyContainerRef.current.getBoundingClientRect();
        // Check if the sticky element is actually stuck at the top
        setIsSticky(rect.top <= 10); // Allow small threshold for rounding
      }
    };

    window.addEventListener("scroll", checkSticky);
    checkSticky(); // Check initial state
    
    return () => window.removeEventListener("scroll", checkSticky);
  }, []);

  useEffect(() => {
    window.dispatchEvent(
      new CustomEvent("sticky-tabs-change", { detail: { isSticky } })
    );
    return () => {
      window.dispatchEvent(
        new CustomEvent("sticky-tabs-change", { detail: { isSticky: false } })
      );
    };
  }, [isSticky]);

  // Scroll the active tab into view on mobile
  // useEffect(() => {
  //   // Scroll the active tab into view
  //   const activeTabElement = document.querySelector(`[data-value="${activeTab}"]`)
  //   if (activeTabElement && tabsContainerRef.current) {
  //     activeTabElement.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" })
  //   }
  // }, [activeTab])


	// const executeScrollX = (tab : any) => { 
	// 	tab?.current?.scrollIntoView({ behavior: "smooth", block: 'nearest', inline: 'center' })
		
	// }

	// useEffect(() => {
	// 	if(isIpad){
	// 		executeScrollX(
	// 			navRefs[activeRef - 1])
	// 	} 
	// }, [activeRef,isIpad,navRefs])
const { openGetInTouchPopup } = useGetInTouchPopupContext();
  return (
    <div>
      <div ref={stickyContainerRef} className={`sticky top-0 z-10 bg-[#F1F2F3] `}>
        <div ref={tabsContainerRef} className="overflow-x-auto mt-[-2px]"> 
          <Tabs
            data={TabsData}
            activeTab={activeTab} 
						navRefs={navRefs}
            setActiveTab={(value: any) => {
              const tab: any = TabsData.find((t: any) => t.value === value);
              if (tab?.ref) handleTabClick(tab.ref, value);
            }}
            customClass=" w-[100%] pl-[1.125rem] pr-0 lg:pl-[2.75rem] lg:px flex items-center  h-[5rem] lg:h-[6rem] !py-12"
            CustomTabsStyle="flex"  
          />
          {isSticky && (
            <div
              className=" px-4 h-2 flex items-center justify-center  text-oWhite-100 rounded-full"
            >
              <CustomButton 
                text="Buy now" 
                customClass="sticky_navbar_icons_button" 
                hasIcon 
                action={() => {
                  gtag.conversion('s22iCL--jN8bELy50MNC');
                  openGetInTouchPopup();
                }} 
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StickyNavComponent;